import React, { useState } from 'react';
import { Button, Row, Form, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import * as worklistActions from '../../actions/worklistActions';
import ClipLoader from 'react-spinners/ClipLoader';
interface Props {
  onClose: () => void;
}

function WorklistTestForm({ onClose }: Props) {
  const [date, setDate] = useState(new Date());
  const [aeTitle, setaeTitle] = useState('');
  const [modality, setModality] = useState('');
  const [validDate, setValidDate] = useState(true);
  const [testResult, setTestResult] = useState<Map<string, number> | null>(null);
  const [pending, setPending] = useState(false);

  function convertToDate(e: String | Date) {
    let interestedDate: Date = new Date();
    if (e instanceof String || e instanceof Date) {
      if (e instanceof String && e.length > 0) {
        const [day, month, year] = e.split('/').map(Number);
        interestedDate = new Date(year, month - 1, day);
      } else if (e instanceof Date) {
        interestedDate = e;
      }
      setDate(interestedDate);
      setValidDate(true);
    } else {
      setValidDate(false);
    }
  }

  function formatDate(d: Date) {
    if (d) {
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return '';
  }

  function test() {
    setPending(true);
    if (modality.length > 0) {
      setModality(modality.toUpperCase());
    }
    worklistActions
      .testWorklist(formatDate(date), aeTitle, modality)
      .then(response => {
        setTestResult(new Map(Object.entries(response)));
      })
      .catch(error => {
        setTestResult(new Map().set('An error has occurred', -2));
      })
      .finally(() => {
        setPending(false);
      });
  }

  return (
    <Form>
      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Scheduled Date
        </Form.Label>
        <Col sm={8} className="worklistNodeForm">
          <DatePicker
            selected={date.toString()}
            onChange={(e: string | Date) => (!isNaN(new Date(e).getTime()) ? convertToDate(e) : '')}
            onInputChange={(e: string | Date) => (!isNaN(new Date(e).getTime()) ? convertToDate(e) : '')}
            placeholderText="Date"
            tabIndex={4}
            dateFormat="dd/MM/yyyy"
            className="form-control form-control-sm"
            formatWeekDay={(day: string) => day.substring(0, 3)}
            isValid={!isNaN(new Date(date).getTime())}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Scheduled AETitle
        </Form.Label>
        <Col sm={8} className="worklistNodeForm">
          <Form.Control
            size="sm"
            type="text"
            name="aeTitle"
            value={aeTitle}
            onChange={e => {
              setaeTitle(e.target.value);
            }}
          />
          <Form.Control.Feedback />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Modality
        </Form.Label>
        <Col sm={8} className="worklistNodeForm">
          <Form.Control
            size="sm"
            type="text"
            name="Modality"
            value={modality}
            onChange={e => {
              setModality(e.target.value);
            }}
          />
          <Form.Control.Feedback />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="worklistTestResultsRow">
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold worklistTestResultsLabel">
          Results
        </Form.Label>
        <Col sm={8} className="worklistNodeForm">
          {pending ? (
            <div className="dashboard-widget-body" style={{ padding: '0' }}>
              Testing...{' '}
              <ClipLoader
                color="#20a8d8"
                cssOverride={{ width: '15px', height: '15px', position: 'relative', top: '3px' }}
              />
            </div>
          ) : testResult ? (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {Array.from(testResult.entries()).map(([nodeName, resultsCount]) => (
                <div key={nodeName + 'Row'} className="worklistTestResultsNodesResults">
                  {nodeName} :{' '}
                  { resultsCount >= 0 ? 'found ' + resultsCount + ' results' : resultsCount === -1? ' unreachable node': ''}
                </div>
              ))}
            </div>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </Col>
      </Form.Group>
      <div style={{ textAlign: 'right', marginTop: '3em' }}>
        <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
          Close
        </Button>
        <Button style={{ width: '8em' }} variant="primary" disabled={pending || !validDate} onClick={() => test()}>
          Test
        </Button>
      </div>
    </Form>
  );
}

export default WorklistTestForm;
